<script setup lang="ts">
import { pushMenuClickCtaEvent } from "~/utils/analytics/clickCta"
import { useMenuStore } from "~/stores/menu"
import { iconsMap } from "~/components/Menu/Utils/DynamicMenuContent.iconMapping"
import { ItemProps } from "./Item.props"

defineProps<ItemProps>()

const menuStore = useMenuStore()

const handleGtm = (label: string) => {
  pushMenuClickCtaEvent(label)
}

const handlePromotions = (label: string) => {
  menuStore.openCloseSidebar(false)
  handleGtm(label)
}
</script>
<template>
  <div
    v-if="!!promotion"
    :key="`link-${promotion.category}`"
    class="flex w-full cursor-pointer items-center justify-between px-4 py-3"
    :style="{
      backgroundColor: `${promotion.backgroundColor}`,
      color: `${promotion.textColor}`
    }"
  >
    <div class="label-menu flex w-full items-center justify-start">
      <component
        class="mr-1 inline-block h-6 w-6"
        v-if="promotion.icon"
        :is="iconsMap[promotion.icon]"
      />
      <AppLink
        @click="() => handlePromotions(promotion.category)"
        class="pig-medium w-full hover:underline"
        :text="promotion.category"
        :to="promotion.categoryLink || '#'"
      />
    </div>
  </div>
</template>
